import s from '../styles/club-horairestarifs.module.css';
import { useState } from "react";
import OJLayout from '../components/layout';
import Link from 'next/link';
import Head from 'next/head';
import * as envConstants from '../components/constants';

// Component des Horaires
const HoraireComponent = ({itemJour}) => {
    const [isHovering, setIsHovered] = useState(false);
    const onSourisEnter = () => {setIsHovered(true);}
    const onSourisLeave = () => {setIsHovered(false);}
    return (        
        <div className={s.divHoraireComponent} onMouseEnter={onSourisEnter} onMouseLeave={onSourisLeave}>
            <p className={`text-2xl font-bold ${isHovering ? "text-ojblack" : "text-ojgreen"}`}>{itemJour}</p>
            <p>Adultes à partir de 15ans</p>
            <p className="text-lg font-bold">20h - 21h30</p>            
        </div>  
    );
};

export default function ClubHorairesTarifs() {
    return (
    <OJLayout>
        <Head><title>{envConstants.SITE_NAME_OJ} - Horaires & Tarifs</title></Head>
        <div className={s.divCHorairesTarifs} >
            {/* Titre de la page */}
            <p className={s.title}>Horaires & Tarifs</p>
            <p>Les cours ont lieu au <Link href="/contact"><a>dojo de Pessac Madran</a></Link> les : </p>
            {/* Horaires des cours + Tarif chez AMPM */}
            <div className={s.divHoraires}>
                <HoraireComponent itemJour={"Mardi"} />
                <div className="flex-grow"/>
                <HoraireComponent itemJour={"Jeudi"} />
            </div>
            <p className={s.tarifs}>Tarif : <span className="font-bold hover:text-ojgreen">290 €</span></p>
            <p>*Tarif applicable pour une saison complète hors vacances scolaires.</p>
            <p>(Inclus : la cotisation, la licence, l’assurance, 1 t-shirt)</p>
            <p>Cependant <span className="text-ojgreen">Open Jujitsu</span> se réserve le droit de proposer des cours supplémentaires qui seront annoncés via les canaux de communication de la Team OJ.</p>
        </div>
    </OJLayout>
)}